import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faGlobe } from '@fortawesome/free-solid-svg-icons';

/**
 * Modal that appears when selectAllMode is active and user triggers an action.
 * Asks whether to apply action to selected rows or ALL products.
 */
export const SelectAllActionModal = ({
    show,
    onClose,
    selectedCount,
    totalProducts,
    actionName = 'this action',
    onSelectedOnly,
    onAllProducts
}) => {
    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Apply to Selected or All Products?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-4">
                    You have <strong>Select All</strong> mode enabled. How would you like to apply {actionName}?
                </p>

                <div className="d-grid gap-3">
                    <Button
                        variant="outline-primary"
                        size="lg"
                        className="d-flex align-items-center justify-content-between p-3"
                        onClick={onSelectedOnly}
                    >
                        <div className="d-flex align-items-center">
                            <FontAwesomeIcon icon={faCheckCircle} className="me-3" size="lg" />
                            <div className="text-start">
                                <div className="fw-bold">Selected Products Only</div>
                                <small className="text-muted">Apply to {selectedCount.toLocaleString()} selected rows</small>
                            </div>
                        </div>
                    </Button>

                    <Button
                        variant="primary"
                        size="lg"
                        className="d-flex align-items-center justify-content-between p-3"
                        onClick={onAllProducts}
                    >
                        <div className="d-flex align-items-center">
                            <FontAwesomeIcon icon={faGlobe} className="me-3" size="lg" />
                            <div className="text-start">
                                <div className="fw-bold">ALL Products</div>
                                <small>Apply to all {totalProducts.toLocaleString()} products in catalog</small>
                            </div>
                        </div>
                    </Button>
                </div>

                <p className="text-muted mt-3 mb-0" style={{ fontSize: '12px' }}>
                    Note: Applying to all products may take some time depending on the action.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SelectAllActionModal;
